import type { Client, User } from '@twilio/conversations';

import { credentialsPromise } from './credentials';

let clientPromise: Promise<Client> | null = null;

export function getClient(): Promise<Client> {
  if (!clientPromise) {
    clientPromise = initializeClient();
  }
  return clientPromise;
}

async function initializeClient(): Promise<Client> {
  try {
    const { user_token } = await credentialsPromise;
    const { Client } = await import('@twilio/conversations');
    const client = new Client(user_token);

    return await new Promise((resolve, reject) => {
      client.on('stateChanged', (state: string) => {
        if (state === 'initialized') {
          resolve(client);
        } else if (state === 'failed') {
          reject(new Error('Twilio initialization error'));
        }
      });
    });
  } catch (error) {
    // Reset clientPromise to allow retries in case of failure
    clientPromise = null;
    throw error; // Rethrow the error to be handled by the caller
  }
}

export async function getTwilioUser(): Promise<User> {
  return (await getClient())?.user;
}
